var Logger = /** @class */ (function () {
    function Logger(namespace, transport) {
        this.namespace = namespace;
        this.transport = transport;
    }
    Logger.prototype.info = function (message) {
        this.transport.send('info', message, { namespace: this.namespace });
    };
    Logger.prototype.warning = function (message) {
        this.transport.send('warning', message, { namespace: this.namespace });
    };
    Logger.prototype.debug = function (message) {
        this.transport.send('debug', message, { namespace: this.namespace });
    };
    Logger.prototype.error = function (message) {
        this.transport.send('error', message, { namespace: this.namespace });
    };
    Logger.prototype.critical = function (message) {
        this.transport.send('error', message, { namespace: this.namespace });
    };
    Logger.prototype.clone = function (namespace) {
        return new Logger(namespace, this.transport);
    };
    return Logger;
}());
export { Logger };
//# sourceMappingURL=Logger.js.map